export class ClearSearchObserver {

  constructor() {
    this.searchResults = document.querySelector('.autocomplete-results')
    this.searchResultsItens = document.querySelector('.autocomplete-results-itens')
  }

  next() {
    this.searchResults.innerHTML = "";
    /* let item = document.createElement('li')
    item.className = "no-results hide-sm"
    item.innerHTML = `Pesquise produtos em toda loja`
    this.searchResults.appendChild(item) */

    //itens
    const lis = this.searchResultsItens.querySelectorAll("li");

    Array.prototype.forEach.call(lis, item =>{
      if(!item.classList.contains("autocomplete-results-itens__item"))
        this.searchResultsItens.removeChild(item)
    });

    Array.prototype.forEach.call(lis, item =>
      item.style.display = "block"
    );
  }

  error(error) {}

  complete() {}

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/search/clearSearch.observer.js